<template>
  <div :style="{'width': imgWidth, 'top': top, 'left': left, 'right': right, 'bottom': bottom}"
       class="cross img-w" :class="`is-${color}`">
    <svg viewBox="0 0 68 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M67.1283 38.387H37.5071L53.5723 22.2892L51.2912 19.9756L35.1935 36.0733V0H31.9348V36.0733L15.8371 19.9756L13.5234 22.2892L29.6212 38.387H0V41.6456H29.6212L13.5234 57.7434L15.8371 60.0244L31.9348 43.9267V80H35.1935V43.9267L51.2912 60.0244L53.5723 57.7434L37.5071 41.6456H67.1283V38.387Z" fill="white"/>
    </svg>
  </div>
</template>

<script>
  export default {
    name: "Cross",
    props: {
      imgWidth: {
        default: '7rem'
      },
      top: {
        default: 'auto'
      },
      left: {
        default: 'auto'
      },
      right: {
        default: 'auto'
      },
      bottom: {
        default: 'auto'
      },
      color: {
        default: 'white'
      }
    },
  }
</script>

<style scoped lang="scss">
.cross {
  position: absolute;
  z-index: 50;

  &.is-yellow {
    svg * {
      fill: $yellow;
    }
  }
  &.is-white {
    svg * {
      fill: white;
    }
  }
  &.is-orange {
    svg * {
      fill: #ffa848;
    }
  }
}
</style>
